import User from '@/models/User';
// import serviceClasses from '@/service-class-config.json';
import { postRequest, getRequest } from '@/api';
import {
  USER_AUTH_MUTATIONS,
  PAUSE_STATE_ENABLE_MUTATIONS,
  PAUSE_STATE_DISABLE_MUTATIONS,
} from '@/store/mutation-types';

export const state = () => {
  return {
    user: new User(),
    userPending: false,
    userError: null,
    pausePending: false,
    pauseError: null,
    key: null,
  };
};
const setDiscounts = (state, commit, dispatch) => {
  commit('cart/setSaldoDiscount', state.user.discount.saldoDiscount / 100, {
    root: true,
  });
  commit('cart/setTopupMin', state.user.discount.topupMin / 100, {
    root: true,
  });
  dispatch('inventory/applyPacketDiscounts', state.user.discount.packets, {
    root: true,
  });
  if (state.user.discount.packetLocale != null) {
    dispatch(
      'campaign/addCampaignMessage',
      state.user.discount.packetLocale.fi,
      {
        root: true,
      }
    );
  }
  if (state.user.discount.saldoLocale != null) {
    dispatch(
      'campaign/addCampaignMessage',
      state.user.discount.saldoLocale.fi,
      {
        root: true,
      }
    );
  }
};
export const actions = {
  async authenticate({ commit, state, dispatch }, key) {
    const success = await postRequest(
      '/login',
      { key },
      USER_AUTH_MUTATIONS,
      commit
    );
    if (success) {
      setDiscounts(state, commit, dispatch);
    }
  },
  async fetch({ commit, dispatch, state }, refetch = false) {
    let path = refetch ? '/users/details?refetch=true' : '/users/details';
    const success = await getRequest(path, USER_AUTH_MUTATIONS, commit);
    if (success) {
      setDiscounts(state, commit, dispatch);
    }
    return success;
  },
  logout({ commit }) {
    postRequest('/users/logout', {}, USER_AUTH_MUTATIONS, commit);
  },
  clearUser({ commit }) {
    commit(USER_AUTH_MUTATIONS.SUCCESS, null);
  },
  async enablePause({ commit }) {
    const success = await postRequest(
      '/users/enablePause',
      {},
      PAUSE_STATE_ENABLE_MUTATIONS,
      commit
    );
    return success;
  },
  async disablePause({ commit }) {
    const success = await postRequest(
      '/users/disablePause',
      {},
      PAUSE_STATE_DISABLE_MUTATIONS,
      commit
    );
    return success;
  },
  setKey({ commit }, key) {
    commit('setKey', key);
  },
};

export const mutations = {
  [USER_AUTH_MUTATIONS.SUCCESS]: (state, user) => {
    if (user) {
      state.user = new User({ ...user, authenticated: true });
    } else {
      state.user = new User();
    }
  },
  [USER_AUTH_MUTATIONS.PENDING]: (state, pending) =>
    (state.userPending = pending),
  [USER_AUTH_MUTATIONS.FAILURE]: (state, error) => (state.userError = error),
  [PAUSE_STATE_ENABLE_MUTATIONS.SUCCESS]: state => {
    state.user.pauseMode = true;
  },
  [PAUSE_STATE_ENABLE_MUTATIONS.PENDING]: (state, pending) =>
    (state.pausePending = pending),
  [PAUSE_STATE_ENABLE_MUTATIONS.FAILURE]: (state, error) =>
    (state.pauseError = error),
  [PAUSE_STATE_DISABLE_MUTATIONS.SUCCESS]: state => {
    state.user.pauseMode = false;
  },
  [PAUSE_STATE_DISABLE_MUTATIONS.PENDING]: (state, pending) =>
    (state.pausePending = pending),
  [PAUSE_STATE_DISABLE_MUTATIONS.FAILURE]: (state, error) =>
    (state.pauseError = error),
  setKey: (state, key) => (state.key = key),
};

export const getters = {
  isAuthenticated: state => state.user.authenticated,
  user: state => state.user,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
